export default __webpack_public_path__ + "logo.e9071e8f.png";